var pug = require("!../../../devtools/node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv ng-transclude\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;


//////////////////
// WEBPACK FOOTER
// ../source/modules/M06-news-list/m06-news-list-component.pug
// module id = 621
// module chunks = 9